import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ScrollToTop } from "@/components/ScrollToTop";
import { A11yProvider, useA11y } from "@/a11y/A11yProvider";
import { AccessibilityWidget } from "@/a11y/AccessibilityWidget";
import { I18nProvider, useT } from "@/i18n/I18nProvider";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import WhyUs from "@/pages/WhyUs";
import Ndis from "@/pages/Ndis";
import MyAgedCare from "@/pages/MyAgedCare";
import About from "@/pages/About";
import Referral from "@/pages/Referral";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

const Shell = () => {
  const { prefs } = useA11y();
  const t = useT();
  return (
    <MotionConfig reducedMotion={prefs.motion ? "always" : "user"}>
      <BrowserRouter>
        <a href="#main" className="skip-link" data-testid="skip-link">{t("Skip to main content")}</a>
        <ScrollToTop />
        <Header />
        <main id="main" tabIndex={-1}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/why-us" element={<WhyUs />} />
            <Route path="/ndis" element={<Ndis />} />
            <Route path="/my-aged-care" element={<MyAgedCare />} />
            <Route path="/apply" element={<Navigate to="/ndis" replace />} />
            <Route path="/about" element={<About />} />
            <Route path="/mission" element={<Navigate to="/about#mission" replace />} />
            <Route path="/referral-form" element={<Referral />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <AccessibilityWidget />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </MotionConfig>
  );
};

function App() {
  return (
    <div className="App">
      <A11yProvider>
        <I18nProvider>
          <Shell />
        </I18nProvider>
      </A11yProvider>
    </div>
  );
}

export default App;
